import { fgFilterEntries } from "@redotech/redo-fulfillment-operations-common/views/fulfillment/fg-filter-catalog";
import CalendarIcon from "@redotech/redo-icons/calendar.svg";
import { DateFilterOperator } from "@redotech/redo-views-common/advanced-filters/date-filter";
import { AdvancedTableFilter } from "@redotech/redo-web/advanced-filters/advanced-filter";

const entry = fgFilterEntries.shippedDate;

export const ShippedDateFilter: AdvancedTableFilter = {
  type: entry.type,
  Icon: CalendarIcon,
  data: {
    name: entry.name,
    type: entry.type,
    value: null,
    operator: DateFilterOperator.WITHIN,
  },
  displayName: entry.displayName,
};
